function EmptyComponent() {
  return <div>No invoices to display</div>;
}

export default EmptyComponent;
